<template>
 <span id="add-case-and-claim">
    <el-button
            v-if="!isEditMode"
            id="add-appointment"
            class="button-action-default"
            size="mini"
            type="success"
            plain
            @click="toggleVisible"
        >
        {{ $t('customerCenter.appointments.newAppointment') }}
        </el-button>

        <i v-if="isEditMode" class="el-icon-edit header-info-dialog-value icon-action" id="btn-unit-detail" @click="toggleVisible" size="mini" icon="el-icon-plus"></i>

        <el-dialog
      id="add-appointment-dialog"
      :title="isEditMode ? '' : $t('customerCenter.appointments.addAppointment')"
      :visible.sync="dialogVisible"
      width="70%"
      class="dialog-with-cols"
      :close-on-click-modal="false"
      append-to-body
      :before-close="closeDialog"
    >

        <el-form v-if="dialogVisible" :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
          <!--Information Section-->
          <el-row :gutter="20">
            <el-col :span="20">
              <span class="title-list">{{ $t('customerCenter.appointments.informationTitle') }}</span>
            </el-col>
          </el-row>

          <el-row>
            <!--Account  -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.account')" prop="accountId" ref="accountId">
                            <master-record-autocomplete
                                :model.sync="form.accountId"
                                labelFieldLastWithDash="number"
                                popperAppendToBody
                                :url="urlConsignee"
                                labelField="name"
                                valueField="id"
                                ref="autocomplete-input-consignee"
                                :placeholder="$t('customerCenter.appointments.placeholder.account')"
                                :edit-value="accountNameToEdit"
                                :disabled="isEditMode"
                                />
                        </el-form-item>
                    </el-col>

                    <!-- Appointment Information -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.appointmentInformation')" prop="appointmentInformation" ref="appointmentInformation">
                            <el-input v-model="form.appointmentInformation" :disabled="true" :placeholder="appointmentInformationPlaceHolder" />
                        </el-form-item>
                    </el-col>

            <!-- Tractor Code -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.tractorNumber')" prop="tractorNumber" ref="tractorNumber">
                            <el-input v-model="form.tractorNumber" :placeholder="$t('customerCenter.appointments.placeholder.tractorNumber')" />
                        </el-form-item>
                    </el-col>

            <!-- FCFS -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.fcfs')" prop="fcfs" ref="fcfs">
                            <el-checkbox
                            v-model="form.fcfs"
                            size="mini"
                            :disabled="isEditMode"
                            />
                        </el-form-item>
                    </el-col>

            <!-- Appointment Date Start-->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="appointmentDateTitle" prop="appointmentStartDate" ref="appointmentStartDate">
                             <el-date-picker
                                v-model="form.appointmentStartDate"
                                class="date-picker-custom"
                                :placeholder="appointmentDatePlaceholder"
                                format="MM/dd/yyyy"
                                :clearable="false"
                                type="date"
                                :disabled="isEditMode"
                            />
                        </el-form-item>
                    </el-col>

                     <!-- Appointment Time start-->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="appointmentTimeTitle" prop="appointmentStartTime" ref="appointmentStartTime">
                            <el-time-picker
                              v-model="form.appointmentStartTime"
                              class="date-picker-custom"
                              :default-value="defaultTimeValue"
                              value-format="HH:mm"
                              format="HH:mm"
                              :placeholder="appointmentTimePlaceholder">
                            </el-time-picker>

                        </el-form-item>
                    </el-col>

                    <!-- Appointment Date End-->
                    <el-col  v-if="isFcfs" :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.appointmentEndDate')" prop="appointmentEndDate" ref="appointmentEndDate">
                             <el-date-picker
                                v-model="form.appointmentEndDate"
                                class="date-picker-custom"
                                :placeholder="$t('customerCenter.appointments.placeholder.appointmentEndDate')"
                                format="MM/dd/yyyy"
                                value-format="yyyy-MM-dd"
                                :clearable="false"
                                :disabled="isEditMode"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Appointment Time end -->
                    <el-col  v-if="isFcfs" :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.appointmentEndTime')" prop="appointmentEndTime" ref="appointmentEndTime">
                            <el-time-picker
                              v-model="form.appointmentEndTime"
                              class="date-picker-custom"
                              :default-value="defaultTimeValue"
                              value-format="HH:mm"
                              format="HH:mm"
                              :placeholder="$t('customerCenter.appointments.placeholder.appointmentEndTime')">
                            </el-time-picker>

                        </el-form-item>
                    </el-col>

            <!-- Note -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.note')" prop="note" ref="note">
                            <el-input
                            v-model="form.note"
                            maxlength="500"
                            type="textarea"
                            :rows="2"
                            :placeholder="$t('customerCenter.appointments.placeholder.note')"
                            />
                        </el-form-item>
                    </el-col>

            <!-- HUB -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.hub')" prop="hub" ref="hub">
                            <hub-select :empty="true" v-model="form.hub"/>
                        </el-form-item>
                    </el-col>

                    <!-- Appointment requested -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.appointmentRequested')" prop="appointmentRequested" ref="appointmentRequested">
                            <el-checkbox
                            v-model="form.appointmentRequested"
                            size="mini"
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Appt Time Requested -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.apptTimeRequested')" prop="apptTimeRequested" ref="apptTimeRequested">
                            <el-input v-model="form.apptTimeRequested" :placeholder="$t('customerCenter.appointments.placeholder.apptTimeRequested')" />
                        </el-form-item>
                    </el-col>

                    <!-- operator -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.operator')" prop="operator" ref="operator">
                            <select-list
                              :model.sync="form.operator"
                              :url="urlOperator"
                              :placeholder="$t('customerCenter.appointments.placeholder.operator')"
                              labelField="userName"
                              :get-params="{ loadNumber: form.loadNumber }"
                              order-by="userName"
                              upper-case-label
                              popperAppendToBody
                              valueField="number"
                              ref="autocomplete-input-operator"
                              :edit-value="form.operator"
                              />
                        </el-form-item>
                    </el-col>
          </el-row>


          <!--Load Details Section-->
          <el-row :gutter="20">
            <el-col :span="20">
              <span class="title-list">{{ $t('customerCenter.appointments.loadDetailsTitle') }}</span>
            </el-col>
          </el-row>

          <el-row>
            <!-- Load Number -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.loadNumber')" prop="loadNumber" ref="loadNumber">
                            <load-number-select
                            :value.sync="form.loadNumber"
                            :url="urlLoadNumber"
                            :default-all="true"
                            label-field="loadNumber"
                            value-field="loadNumber"
                            :current-value-object="{ loadNumber: form.loadNumber, trailer_id: form.loadNumber }"
                            ref="filter-load-number-select"
                            :get-params="{ consigneeId: form.accountId, shipDate: form.shipDate }"
                            :key="urlLoadNumber"
                            :empty-value="true"
                            @change="handleLoadNumberChange"
                            />
                          </el-form-item>
                    </el-col>

                    <!-- Ship Date -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.shipDate')" prop="shipDate" ref="shipDate">
                            <el-date-picker
                                v-model="form.shipDate"
                                class="date-picker-custom"
                                :placeholder="$t('customerCenter.appointments.placeholder.shipDate')"
                                size="mini"
                                format="MM/dd/yyyy"
                                :clearable="false"
                                type="date"
                                @change="() => { this.$refs['filter-load-number-select'].search(); }"
                            />
                        </el-form-item>
                    </el-col>
          </el-row>

          <!--Shipper Purchase Section-->
          <el-row :gutter="20">
            <el-col :span="20">
              <span class="title-list">{{ $t('customerCenter.appointments.shipperAndPurchasesTitle') }}</span>
            </el-col>
          </el-row>

          <el-row :gutter="12">
            <!-- Shhipper -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.shipper')" prop="shipper" ref="shipper">
                            <master-record-autocomplete
                                :model.sync="shipperId"
                                :modelAdditional.sync="shipperName"
                                :url="urlShipper"
                                :placeholder="$t('customerCenter.appointments.placeholder.shipper')"
                                labelField="shipperAccountName"
                                popperAppendToBody
                                labelFieldLastWithDash="shipperAccountNumber"
                                valueField="id"
                                valueFieldAdditional="shipperAccountName"
                                ref="autocomplete-input-shipper"
                                :edit-value="shipperName"
                                />
                        </el-form-item>
                    </el-col>

            <!-- Purchase -->
                    <el-col :span="6" class="form-vertical-item">
                        <el-form-item :label="$t('customerCenter.appointments.purchase')" prop="purchase" ref="purchase">
                            <el-input v-model="purchase"  :placeholder="$t('customerCenter.appointments.placeholder.purchase')" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" class="form-vertical-item">
                    <el-form-item>
                      <span slot="label">&#8203;</span>
                        <el-button
                            type="primary"
                            size="mini"
                            @click="handleShipperPurchaseAction"
                        >
                            {{ $t('customerCenter.appointments.addPurchaseButton') }}
                        </el-button>
                    </el-form-item>
                </el-col>
              </el-row>

          <div style="max-width: 1000px; width: 100%; margin: auto;">
            <el-table
            v-if="form.purchasesByShipper.length>0"
            :data="form.purchasesByShipper"
            id="purchasesManagement-data-list"
            ref="purchasesTable"
            size="mini"
            tooltip-effect="dark"
            class="dark-blue-table"
            stripe>
              <el-table-column prop="shipperName" :label="$t('customerCenter.appointments.shipper')" :min-width="7"
                         align="center"></el-table-column>
              <el-table-column prop="purchase" :label="$t('customerCenter.appointments.purchase')" :min-width="7"
                         align="center"></el-table-column>
              <el-table-column prop="action" :label="$t('customerCenter.appointments.options')" :min-width="4" align="center">
                <template slot-scope="scope">
                  <el-button
                  type=""
                  icon="el-icon-edit"
                  size="mini"
                  @click="editPurchaseItem(scope.row)"
                  style="border: none; background-color: transparent; margin-right: 0px;"
                >
                </el-button>

                <el-button
                type=""
                icon="el-icon-delete"
                size="mini"
                @click="removePurchaseItem(scope.row)"
                style="border: none; background-color: transparent; text-align: left; margin-left: 0px;"
                >
                </el-button>
                </template>

              </el-table-column>
            </el-table>
          </div>

        </el-form>

          <div
          id="add-case-and-claim-dialog-footer"
          slot="footer"
          class="dialog-footer form-vertical-item flex-reverse-direction"
        >

          <el-button
            type="primary"
            id="save-storage-location-button"
            @click="submitForm()"
            size="mini"
            :disabled="isEditEnabled()"
          >{{ $t('common.save') }}</el-button>
          <el-button
            id="refresh-storage-location-button"
            @click="resetForm()"
            size="mini"
          >{{ $t('common.clear') }}</el-button>
        </div>

        </el-dialog>
 </span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import { APPOINTMENTS_SAVE, APPOINTMENTS_SEARCH, ACCOUNT_SEARCH_BY_ID } from '@/store/actions';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import SelectList from '@/components/Select/SelectList';
import MasterRecordAutocomplete from '../../../components/autocomplete/MasterRecordAutocomplete';
import HubSelect from '../hubSelect/HubSelect';
import LoadNumberSelect from '../loadNumberSelect/LoadNumberSelect';

export default {
  name: 'AddAppointments',
  components: {
    MasterRecordAutocomplete,
    HubSelect,
    LoadNumberSelect,
    SelectList
  },
  props: {
    appointment: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['customerMasterRecord']),
    isEditMode() {
      return this.appointment && Object.keys(this.appointment).length > 0;
    },
    isFcfs() {
      return this.form.fcfs;
    },
    appointmentDateTitle() {
      return this.form.fcfs
        ? this.$t('customerCenter.appointments.appointmentStartDate')
        : this.$t('customerCenter.appointments.appointmentDate');
    },
    appointmentTimeTitle() {
      return this.form.fcfs
        ? this.$t('customerCenter.appointments.appointmentStartTime')
        : this.$t('customerCenter.appointments.appointmentTime');
    },
    appointmentDatePlaceholder() {
      return this.form.fcfs
        ? this.$t('customerCenter.appointments.placeholder.appointmentStartDate')
        : this.$t('customerCenter.appointments.placeholder.appointmentDate');
    },
    appointmentTimePlaceholder() {
      return this.form.fcfs
        ? this.$t('customerCenter.appointments.placeholder.appointmentStartTime')
        : this.$t('customerCenter.appointments.placeholder.appointmentTime');
    },
    defaultTimeValue() {
      const nowTime = new Date();
      return new Date(0, 0, 0, nowTime.getHours(), 0, 0);
    }
  },
  watch: {
    appointment: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0 && this.dialogVisible) {
          this.fillForm();
        }
      },
      deep: true
    },
    // eslint-disable-next-line func-names
    'form.accountId': async function (newValue) {
      if (newValue) {
        try {
          await this.$store.dispatch(ACCOUNT_SEARCH_BY_ID, newValue);

          if (this.customerMasterRecord) {
            this.form.appointmentInformation = this.customerMasterRecord.accountDetails.appointmentInformation;
            this.appointmentInformationPlaceHolder = null;
          }

          this.urlShipper = `${apiConstants.END_POINTS.ACCOUNTS.SHIPPERS_BY_CONSIGNEE}/${newValue}`;
          this.urlLoadNumber = `${apiConstants.END_POINTS.ACCOUNTS.LOAD_NUMBERS_BY_CONSIGNEE}/${newValue}`;
          this.fillForm();
          // eslint-disable-next-line no-empty
        } catch (error) {
        }
      }
    },

  },
  data() {
    return {
      dialogVisible: false,
      form: {
        accountId: null,
        tractorNumber: null,
        appointmentStartDate: null,
        appointmentEndDate: null,
        appointmentStartTime: null,
        appointmentEndTime: null,
        fcfs: false,
        note: null,
        hub: null,
        appointmentRequested: false,
        apptTimeRequested: null,
        loadNumber: null,
        shipDate: null,
        sent: false,
        purchasesByShipper: []
      },
      accountNameToEdit: null,
      purchaseId: null,
      shipperId: null,
      shipperName: null,
      purchase: null,
      appointmentInformationPlaceHolder: this.$t('customerCenter.appointments.placeholder.appointmentInformation'),
      // appointmentTimeTitle: this.$t('customerCenter.appointments.appointmentDate'),
      formRules: {
        accountId: [
          {
            required: true,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'submit'
          },
        ],
        tractorNumber: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        appointmentStartDate: [
          {
            required: true,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        appointmentEndDate: [
          {
            required: true,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        appointmentStartTime: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        appointmentEndTime: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        fcfs: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        note: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        hub: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        appointmentRequested: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        apptTimeRequested: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        loadNumber: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        shipDate: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
        purchasesByShipper: [
          {
            required: false,
            message: this.$t('customerCenter.appointments.error.fieldRequired'),
            trigger: 'blur'
          },
        ],
      },
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      urlShipper: `${apiConstants.END_POINTS.ACCOUNTS.SHIPPERS_BY_CONSIGNEE}/0`,
      urlLoadNumber: apiConstants.END_POINTS.ACCOUNTS.LOAD_NUMBERS_BY_CONSIGNEE,
      urlOperator: apiConstants.END_POINTS.ACCOUNTS.OPERATORS_SEARCH
    };
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false;
      this.form.loadNumber = null;
      this.resetForm();
    },
    toggleVisible() {
      this.dialogVisible = !this.dialogVisible;
      if (this.dialogVisible) {
        this.fillForm();
      }
    },
    handleShipperPurchaseAction() {
      if (this.shipperId !== null && this.shipperName !== null) {
        this.form.purchasesByShipper.push({
          id: this.purchaseId,
          shipperId: this.shipperId,
          shipperName: this.shipperName,
          purchase: this.purchase
        });
        this.purchaseId = null;
        this.shipperId = null;
        this.shipperName = null;
        this.purchase = null;
      }
    },
    editPurchaseItem(item) {
      this.purchaseId = item.id;
      this.shipperId = item.shipperId;
      this.shipperName = item.shipperName;
      this.purchase = item.purchase;
      const index = this.form.purchasesByShipper.indexOf(item);
      if (index !== -1) {
        this.form.purchasesByShipper.splice(index, 1);
      }
    },
    removePurchaseItem(item) {
      const index = this.form.purchasesByShipper.indexOf(item);
      if (index !== -1) {
        this.form.purchasesByShipper.splice(index, 1);
      }
    },
    isEditEnabled() {
      if (!this.isEditMode) {
        return false;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const appointmentDate = new Date(this.form.appointmentStartDate);
      appointmentDate.setHours(0, 0, 0, 0);
      return today > appointmentDate;
    },
    fillForm() {
      if (this.isEditMode) {
        this.form.id = this.appointment.id;
        this.form.accountId = this.appointment.accountId;
        this.accountNameToEdit = this.appointment.accountName;
        this.form.tractorNumber = this.appointment.tractorNumber;
        this.form.appointmentStartDate = this.appointment.appointmentStartDate
          ? new Date(`${this.appointment.appointmentStartDate}T00:00:00`)
          : null;
        this.form.appointmentEndDate = this.appointment.appointmentEndDate
          ? new Date(`${this.appointment.appointmentEndDate}T00:00:00`)
          : null;
        this.form.appointmentStartTime = this.appointment.appointmentStartTime;
        this.form.appointmentEndTime = this.appointment.appointmentEndTime;
        this.form.fcfs = this.appointment.fcfs;
        this.form.note = this.appointment.note;
        this.form.hub = this.appointment.hub;
        this.form.appointmentRequested = this.appointment.appointmentRequested;
        this.form.apptTimeRequested = this.appointment.apptTimeRequested;

        this.form.shipDate = this.appointment.shipDate
          ? new Date(`${this.appointment.shipDate}T00:00:00`)
          : null;
        this.form.sent = this.appointment.sent;
        this.form.loadNumber = this.appointment.loadNumber;
        this.form.purchasesByShipper = JSON.parse(JSON.stringify(this.appointment.purchasesByShipper || []));

        this.$nextTick(() => {
          this.form.loadNumber = this.appointment.loadNumber;
        });
      }
    },
    resetForm() {
      if (!this.isEditMode) {
        this.form = {
          accountId: null,
          tractorNumber: null,
          appointmentStartDate: null,
          appointmentEndDate: null,
          appointmentStartTime: null,
          appointmentEndTime: null,
          fcfs: false,
          note: null,
          hub: null,
          appointmentRequested: false,
          apptTimeRequested: null,
          loadNumber: null,
          shipDate: null,
          sent: false,
          purchasesByShipper: []
        };
        this.accountNameToEdit = null;
        this.shipperId = null;
        this.shipperName = null;
        this.purchase = null;
        this.urlShipper = apiConstants.END_POINTS.ACCOUNTS.SHIPPERS;
        this.urlLoadNumber = apiConstants.END_POINTS.ACCOUNTS.LOAD_NUMBERS_BY_CONSIGNEE;
        this.appointmentInformationPlaceHolder = this.$t('customerCenter.appointments.placeholder.appointmentInformation');
        this.urlShipper = `${apiConstants.END_POINTS.ACCOUNTS.SHIPPERS_BY_CONSIGNEE}/0`;
        this.urlLoadNumber = apiConstants.END_POINTS.ACCOUNTS.LOAD_NUMBERS_BY_CONSIGNEE;
      } else {
        this.fillForm();
      }
    },
    submitForm() {
      this.form.hub = this.form.hub !== ' ' ? this.form.hub : null;
      this.form.sent = this.shouldSent();
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);

            this.$store.dispatch(APPOINTMENTS_SAVE, this.form)
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.closeDialog();
                this.$store.dispatch(APPOINTMENTS_SEARCH);
                this.$emit('appointment-saved', this.form);
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          }
        });
      });
    },
    shouldSent() {
      return this.form.appointmentStartTime !== this.appointment.appointmentStartTime
          || this.form.appointmentEndTime !== this.appointment.appointmentEndTime
          || this.form.note !== this.appointment.note;
    },
    handleLoadNumberChange() {
      setTimeout(() => { this.$refs['autocomplete-input-operator'].search(); }, 100);
    }
  },
};

</script>

<style scoped>
.date-picker-custom {
  width: 100%;
}
.custom-date-picker .el-input__inner {
  height: 32px;
  font-size: 14px;
}

/* Ensure element-ui cols inside this dialog wrap correctly and don't overflow */
.dialog-with-cols .el-dialog__body .el-row {
  display: flex;
  flex-wrap: wrap;
}
.dialog-with-cols .el-dialog__body .el-col {
  box-sizing: border-box;
  min-width: 0;
}
</style>
